import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { React, useState } from 'react';
import Colors from '../../colors';
import { NOTES } from '../../constants';
import MultilineInput from '../MultilineInput';
import PhoneTextInput from '../PhoneTextInput';
import TextInput from '../TextInput';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ModalContainer from './ModalContainer';
import ModalTitle from './Text/ModalTitle';

const style = {
    width: '100%',
    p: 1,
};

const ButtonContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
});

function AddMemberModal({
    isVisible,
    setIsVisible,
    setFirstNameText,
    setLastNameText,
    setPhoneNumText,
    setNotesText,
    onClickAddMember,
    firstName,
    lastName,
    phoneNumber
}) {

    const [errMsg, setErrMsg] = useState();

    const handleMissingRequirements = () => {
        if (firstName.trim().length === 0 || lastName.trim().length === 0) {
            setErrMsg('Please give the member a full name.');
            return;
        }
    };

    const handleClose = () => setErrMsg();

    const errMsgStyles = {
        color: 'red',
        marginTop: '-12px'
    }

    return (
        <ModalContainer
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            onClose={handleClose} >
            <Box sx={style}>
                <ModalTitle
                    label={'Add Member'} />
                <TextInput
                    label={'First Name'}
                    setText={setFirstNameText} />
                <TextInput
                    label={'Last Name'}
                    setText={setLastNameText} />
                <PhoneTextInput
                    label={'Phone Number (Optional)'}
                    phoneNumberText={phoneNumber}
                    setPhoneNumberText={setPhoneNumText} />
                <MultilineInput
                    label={'Notes (optional)'}
                    placeholder={NOTES}
                    maxChars={250}
                    setText={setNotesText} />
            </Box>

            {errMsg && <span style={errMsgStyles}>{errMsg}</span>}

            <ButtonContainer>
                {firstName.trim().length === 0 || lastName.trim().length === 0
                    ? <OutlineButton
                        color={Colors.mediumGray}
                        label={'Save'}
                        onClick={handleMissingRequirements}>
                    </OutlineButton>
                    :
                    <OutlineButton
                        color={Colors.green}
                        label={'Save'}
                        onClick={onClickAddMember} />
                }
            </ButtonContainer>
        </ModalContainer>
    );
}

export default AddMemberModal;